/**
 * Privacy modal — abre via #openPrivacy, fecha via #closePrivacy, Esc ou backdrop click.
 * Trava scroll do body enquanto aberto. Restaura foco no opener ao fechar.
 */

const OPEN_BTN_ID = 'openPrivacy';
const CLOSE_BTN_ID = 'closePrivacy';
const MODAL_ID = 'privacyModal';
const OPEN_CLASS = 'open';

export function initPrivacyModal(): () => void {
  const openBtn = document.getElementById(OPEN_BTN_ID);
  const closeBtn = document.getElementById(CLOSE_BTN_ID);
  const modal = document.getElementById(MODAL_ID);
  if (!openBtn || !closeBtn || !modal) return () => {};

  let opener: HTMLElement | null = null;

  function setOpen(open: boolean): void {
    if (!modal) return;
    modal.classList.toggle(OPEN_CLASS, open);
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      const focusable = modal.querySelector<HTMLElement>('[id="closePrivacy"], button, [href]');
      focusable?.focus();
    } else {
      opener?.focus();
      opener = null;
    }
  }

  const onOpen = (e: Event): void => {
    opener = e.currentTarget as HTMLElement | null;
    setOpen(true);
  };
  const onClose = (): void => setOpen(false);
  const onBackdrop = (e: MouseEvent): void => {
    if (e.target === modal) setOpen(false);
  };
  const onKey = (e: KeyboardEvent): void => {
    if (e.key === 'Escape' && modal.classList.contains(OPEN_CLASS)) {
      setOpen(false);
    }
  };

  openBtn.addEventListener('click', onOpen);
  closeBtn.addEventListener('click', onClose);
  modal.addEventListener('click', onBackdrop);
  document.addEventListener('keydown', onKey);

  return () => {
    openBtn.removeEventListener('click', onOpen);
    closeBtn.removeEventListener('click', onClose);
    modal.removeEventListener('click', onBackdrop);
    document.removeEventListener('keydown', onKey);
  };
}
